/** @format */

import { Paper, Typography } from '@mui/material';
import { flexRender } from '@tanstack/react-table';

export default function TableBody({ rows }) {
  return (
    <Paper component="tbody" elevation={2}>
      {rows.map((row) => (
        <tr key={row.id}>
          {row.getVisibleCells().map((cell) => (
            <Typography
              component="td"
              key={cell.id}
              sx={{
                p: 1,
                whiteSpace: 'normal',
                wordBreak: 'break-word',
                // overflowWrap: 'break-word',
                fontSize: '0.8rem',
                textAlign: 'center',
              }}
            >
              {flexRender(cell.column.columnDef.cell, cell.getContext())}
            </Typography>
          ))}
        </tr>
      ))}
    </Paper>
  );
}
